import React from "react"
import css from "./Radio.scss"
import { PropTypes } from "prop-types"

function Radio({ child, isSelected, isDisabled, onClick, className, name, centerAlign, ariaLabelledBy, id }) {
    const handleChange = () => {
        if (!isDisabled) {
            onClick && onClick()
        }
    }

    return (
        <div
            className={`flex ${className || ""} ${centerAlign ? "alignCenter" : ""}`}
            onClick={() => handleChange()}
        >
            <input
                id={id}
                className={`${css.radioInput} ${isDisabled ? css.disabledInput : ""} pointer`}
                type={"radio"}
                name={name}
                disabled={isDisabled}
                checked={isSelected}
                aria-labelledby={ariaLabelledBy}
                readOnly // This is because we have onClick on parent not on input
            />
            {child}
        </div>
    )
}

Radio.propTypes = {
    child: PropTypes.node,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    centerAlign: PropTypes.bool,
    ariaLabelledBy: PropTypes.string,
    id: PropTypes.string,
}

Radio.defaultProps = {
    centerAlign: false,
}

export default Radio
